<template v-if="user">
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">
             <div class="row pt-4">
               <div class="col-sm-12">
                 <div class="alert alert-danger" role="alert" v-if="errors.length" v-for="error in errors">
                   {{ error }}
                 </div>
                 <div class="alert alert-success" role="alert" v-if="successes.length" v-for="success in successes">
                   {{ success }}
                 </div>
                 <div class="element-wrapper">
                   <h6 class="element-header">
                     Finder Settings
                   </h6>
                   <div class="element-box">
                     <div class="form-group">
                       <label for=""> Full Name (<b>Only seen to authorized users</b>)</label><input class="form-control" v-model="fullName" placeholder="Adam Smith" type="text">
                     </div>
                     <div class="form-group">
                       <label for=""> Your Current Location</label><app-places class="form-control" v-model="location" placeholder="Enter your city" @change="val => { mapsLocation = val }" :options="{ countries: ['ID'], type: 'city', language: 'id' }"></app-places>
                     </div>
                     <div class="form-group">
                       <label for=""> Select Role(s)</label><app-select2 class="form-control" v-model="roles">
                         <option value="leader">
                           Leader
                         </option>
                         <option value="fragger">
                           Fragger
                         </option>
                         <option value="awper">
                           AWPer
                         </option>
                         <option value="rifler">
                           Rifler
                         </option>
                         <option value="coach">
                           Coach
                         </option>
                       </app-select2>
                     </div>
                     <div class="form-group">
                       <label for=""> Language(s)</label><app-select2 class="form-control" v-model="languages">
                         <option value="en">
                           English
                         </option>
                         <option value="id">
                           Bahasa Indonesia
                         </option>
                         <option value="javanese">
                           Bahasa Jawa
                         </option>
                         <option value="sundanese">
                           Bahasa Sunda
                         </option>
                       </app-select2>
                     </div>
                     <div class="form-group">
                       <label for=""> Your Goal(s)</label><app-select2 class="form-control" v-model="goals">
                         <option value="fun">
                           Play for fun
                         </option>
                         <option value="competitively">
                           Play competitively
                         </option>
                         <option value="professionally">
                           Play professionally
                         </option>
                       </app-select2>
                     </div>
                     <div class="form-group">
                       <label for=""> Your Abilities</label><app-select2 class="form-control" v-model="abilities">
                         <option value="offline">
                           Play Offline (LAN)
                         </option>
                         <option value="travelling">
                           Travelling
                         </option>
                       </app-select2>
                     </div>
                     <div class="form-check" v-if="($root.communityProfile.rank.name === 'Premium+') || ($root.communityProfile.rank.name === 'moderator') || ($root.communityProfile.rank.name === 'owner') || ($root.communityProfile.rank.name === 'admin')">
                       <label class="form-check-label"><input class="form-check-input" type="checkbox" v-model="boosted">Boosted</label>
                     </div>
                     <div class="form-check">
                       <label class="form-check-label"><input class="form-check-input" type="checkbox" v-model="enabled">Enabled</label>
                     </div>
                     <div class="form-buttons-w">
                       <button class="btn btn-primary" type="submit" @click="updateSettings()"> Update</button>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.authenticated"></app-invitation>
           </div>
           <app-rightsidebar></app-rightsidebar>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from '../partials/Navbar';
import Sidebar from '../partials/Sidebar';
import Alert from '../partials/Alert';
import DarkColor from '../partials/DarkColor';
import RightSidebar from '../partials/RightSidebar';
import Invitation from '../partials/Invitation';
import Select2 from '../partials/Select2';
import Places from '../partials/Places';

export default {
  name: 'Servers',
  metaInfo: {
    title: 'servers',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | servers' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/servers'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | servers' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      fullName: '',
      location: '',
      languages: [],
      roles: [],
      goals: [],
      abilities: [],
      mapsLocation: null,
      enabled: false,
      boosted: false,
      errors: [],
      successes: []
    }
  },
  computed: {
    //
  },
  methods: {
    getSettings() {
      this.axios.get(`${this.API_URL}/finder/@me/player`).then((res) => {
        this.fullName = res.data.fullName;
        this.roles = res.data.roles;
        this.languages = res.data.languages;
        this.goals = res.data.goals;
        this.abilities = res.data.abilities;
        this.enabled = res.data.enabled;
        this.boosted = res.data.boosted;
        if (res.data.location.value) {
          this.mapsLocation = res.data.location;
          this.location = res.data.location.value;
        }
      });
    },
    updateSettings() {
      if (this.fullName.length < 4) {
        this.errors.push('Full Name must be more than 5 characters!');
        setTimeout(() => {
          this.errors = [];
        }, 3000)
        return
      }

      if (this.roles.length <= 0) {
        this.errors.push('You must select a role!');
        setTimeout(() => {
          this.errors = [];
        }, 3000)
        return
      }

      if (this.languages.length <= 0) {
        this.errors.push('You must select a language!');
        setTimeout(() => {
          this.errors = [];
        }, 3000)
        return
      }

      if (this.goals.length <= 0) {
        this.errors.push('You must select a goal!');
        setTimeout(() => {
          this.errors = [];
        }, 3000)
        return
      }

      if (this.abilities.length <= 0) {
        this.errors.push('You must select an ability!');
        setTimeout(() => {
          this.errors = [];
        }, 3000)
        return
      }

      if (!this.mapsLocation) {
        this.errors.push('You must select a location!');
        setTimeout(() => {
          this.errors = [];
        }, 3000)
        return
      }

      this.axios.patch(`${this.API_URL}/finder/@me/player`, { fullName: this.fullName, roles: this.roles, languages: this.languages, goals: this.goals, enabled: this.enabled, location: this.mapsLocation, abilities: this.abilities, boosted: this.boosted }).then((res) => {
        this.successes.push('Finder Settings has been successfully updated!');
        setTimeout(() => {
          this.successes = [];
        }, 2000)
      });
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  created() {
    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    this.getSettings();
  },
  mounted() {
    //
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation,
    'app-select2': Select2,
    'app-places': Places
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
